import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";

const AgencyLayout = () => {
  return (
    <div className="min-h-screen bg-[#F7F8FA] dark:bg-[#080808] transition-colors" data-testid="agency-layout">
      <Sidebar />
      <main className="lg:pl-72">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-8 lg:py-12">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AgencyLayout;
